import React from 'react'

const Voucher = () => {
  return (
    <div>Voucher</div>
  )
}

export default Voucher